<template>
    <div @click="clickCampaign()">
        <div class="wrapper-campaign-item">
            <div class="wrapper-campaign">
                <div class="wrapper-img-campaign">
                    <div class="img-flag" v-if="campaign.qty <= 0">สิทธิ์เต็ม</div>
                    <div class="img-filter" v-if="campaign.qty <= 0"></div>
                    <div class="img-campaign">
                        <img :src="campaign.fullImageUrl" 
                            class="card-img-top" />
                    </div>
                </div>

                <div class="wrapper-info">
                    <div class="campaign-name">{{campaign.name}}</div>
                    <!-- <div class="point">{{getPointMessage()}}</div> -->
                    <div class="campaign-point">
                        <div class="text">
                        <span class="use-point">{{campaign.pointPerUnit | number_format}}</span>
                            <span>
                                <img class="icon-point" src="@/assets/icon/reward_icon_coin@3x.png" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js"
import CacheHelper from "@/helper/CacheHelper.js";

export default {
    name: 'CampaignItem',
    props: {
        index: Number,
        campaign: Object,
        type: String,
    },
    data: function() {
        return {

        };
    },
    created: function() {
        //console.log('lblCampaign',this.campaign);
    },
    mounted: function () {
        //this.lblCampaign = this.lbl.campaign;
    },
    methods: {
        //event
        clickCampaign: function () {
            var cache = new CacheHelper('session');
            if(cache.getCache('isFromBDM')){
                cache.removeCache('isFromBDM');
            }
            
            var path = '/luckydraw/' + this.campaign.id;
            this.$router.push(path);
        },
        //method
        isSoldOut: function () {
            return this.campaign.qty < 1
                ? true
                : false
        },
        //utility
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lblCampaign.get_point : this.lblCampaign.use_point;
            var pointUnit = this.lblCampaign.point + (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseImage.scss";
@import "@/style/base/baseText.scss";
@import "@/style/base/baseDisplay.scss";

.wrapper-campaign-item {
    width: 100%;

    .wrapper-campaign {
        border-radius: 15px;
        background-color: $white;
        box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.16);
        //padding: 10px;
        margin-bottom: 15px;
        
        .wrapper-img-campaign {
            position: relative;

            .img-filter{
                width: 100%;
                height: 100%;
                background-color: $dark-blue;
                opacity: 0.55;
                position: absolute;
                z-index: 1;               
            }

            .img-flag{
                width: 120px;
                height: 120px;
                background-color: $dark-blue;
                border-radius: 50%;
                color: $white;
                font-size: 1.25rem;
                text-align: center;
                margin: auto;
                padding: 45px 0;
                position: absolute;
                z-index: 2;
                left: 0;
                right: 0;
                top: 25%;
                opacity: 0.9;

                @include mini-mobile(){
                    width: 100px;
                    height: 100px;
                    font-size: 1rem;
                    padding: 38px 0;
                }
            }

            .img-campaign{
                @include baseRatioImg(66.66%);
                border-top-left-radius: 15px;
                border-top-right-radius: 15px;

                img {
                    border: 0px;
                    
                    &.img-rectangle{
                        @include baseRatioImg(66.66%);
                    }
                    // &.image-gray{
                    //     -webkit-filter: grayscale(100%);
                    //     filter: grayscale(100%);
                    // }
                }
            }
            
        }
        .wrapper-info {
            @extend %display-flex;
            width: 100%;
            padding: 15px;

            .campaign-name {
                @extend %ellipsis-2;
                flex: 0 0 calc(100% - 100px);
                width: calc(100% - 100px);
                font-size: 1.12rem;
                line-height: 1.5;
                text-align: left;
                color: $bright-gray;

                @include mini-mobile() {
                    font-size: 1rem;
                }
            }

            .campaign-point {
                flex: 0 0 100px;
                width: 100px;
                height: 33px;
                position: relative;
                font-size: 1.8rem;
                padding: 1px 4px 1px 12px;
                border-radius: 30px;
                background-color: #617792;
                margin: auto;
                .text {
                    @extend %display-flex;
                    width: 100%;

                    .use-point {
                        flex: 0 0 65%;
                        width: 70%;
                        margin-top: 8px;
                        font-family: 'Medium';
                        font-size: 1.12rem;
                        line-height: 1;
                        text-align: left;
                        color: $white;

                        @include mini-mobile() {
                            font-size: 1rem;
                            // flex: 0 0 57%;
                            // width: 57%;
                        }
                    }
                    .icon-point {
                        flex: 0 0 35%;
                        width: 25px;
                        margin-top: -15px;

                        @include mini-mobile() {
                            flex: 0 0 43%;
                            width: 20px;
                        }
                    }
                }

            }
        }
    }
}
</style>
